
<script>

import { defineComponent } from 'vue'

//data
import { getLibraryOptions } from '@/services/serviceLibrary';

export default defineComponent({
  name: 'PluginLibraryToArticle',
	data() {
		return {
			preloader:false,
			optionsLibraries: [],
			selectedLibrary:''
		}
	},
  props: {
	'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String
  },
  emits: ["changeAfterSelect"],
  components: {
    
  }
  ,mounted () {

  },
  
	methods: {
		
		loadLibraries:function(){
				
			this.preloader=true
			
			getLibraryOptions().then(response => {
				if(!response.statusText){
					this.preloader=false
					this.optionsLibraries = response.optionsLibraries;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},

		onSelect:function(e){
			this.$emit('changeAfterSelect',e)
		},

		onCloseModal:function(){
			this.modalObject.hide();
		}

	},
	
	watch: {
		modalId() {
			this.loadLibraries();
		},
	},
	
	created() {

	}
})
</script>

<template>
  <div>

	<div class="modal fade" :id="modalId" tabindex="-1" >
		<div class="modal-dialog modal-fullscreen modal-dialog-scrollable">	
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.Library') }}</h6>
				</div>
				
				<div class="modal-body">
					
					<div class="row">
						<div class="input-group col-md-4 col-12">
							<select v-model='selectedLibrary' class="form-control form-control-sm" >
								<option  value="">{{ $t('msgCore.selectLibrary') }}</option>
								<option v-for="(option) in optionsLibraries" :value="option.value" :key="option">{{ option.title }}</option>
							</select>
							<button type="button" :title="$t('msgCore.btnSend')" class="btn btn-info btn-sm my-btn" v-on:click="onSelect(selectedLibrary)">
								Odoslať
							</button>
						</div>
					</div>
									
				</div>
				
				<div class="modal-footer">
					<div class="btn-group">
						<button type="button" v-on:click="onCloseModal()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
					</div>	
				</div>

			</div>

		</div>
		
	</div>


  </div>
</template>